import { render, staticRenderFns } from "./LpuLoyaltyProgram.vue?vue&type=template&id=92a47b0a&"
import script from "./LpuLoyaltyProgram.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLoyaltyProgram.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a47b0a')) {
      api.createRecord('92a47b0a', component.options)
    } else {
      api.reload('92a47b0a', component.options)
    }
    module.hot.accept("./LpuLoyaltyProgram.vue?vue&type=template&id=92a47b0a&", function () {
      api.rerender('92a47b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/LpuLoyaltyProgram.vue"
export default component.exports